import axios from '@/lib/AxApi';

export default {
  getFromAndToUsers(params, cb)
  {
    axios.get('/rest/WorkOrderTasks/getFromAndToUsers',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getTasksByFromTo(params, cb)
  {
    axios.get('/rest/WorkOrderTasks/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  toggleTask(params, cb)
  {
    axios.post('/rest/WorkOrderTasks/toggleTask', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/workordertasks.js